import type { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { AreaGate, InicioDaArea } from '../../core/areas/AreaGate'
import { VoltouParaLogistica } from '../../core/areas/VoltouParaLogistica'
import { PermissionGate } from '../../core/router/guards'
import { cargosConfig, usuariosConfig } from '../../features/cadastros/configs'
import { AuditoriaPage, ResourceFormPage, ResourceListPage, UsuarioFormPage } from '../../core/router/telas'

/** As rotas da área Administrativo: Usuários, Cargos e Auditoria. Cada tela segue
 *  com o portão da própria key: entrar na área não dá nenhuma delas a ninguém. */
export function rotasDoAdministrativo(): ReactElement {
  return (
    <>
      <Route path="/administrativo/cadastros/*" element={<VoltouParaLogistica />} />
      <Route path="/administrativo/categorias/*" element={<VoltouParaLogistica />} />
      <Route path="/administrativo" element={<AreaGate area="administrativo" />}>
        <Route index element={<InicioDaArea area="administrativo" />} />

        {/* Usuários: a lista no config; o criar e editar têm seis abas de vinculação,
            que não cabem na casca genérica de cartão único. */}
        <Route path="/administrativo/usuarios" element={<PermissionGate permission="users.view"><ResourceListPage config={usuariosConfig} /></PermissionGate>} />
        <Route path="/administrativo/usuarios/new" element={<PermissionGate permission="users.view"><UsuarioFormPage variante="backoffice" /></PermissionGate>} />
        <Route path="/administrativo/usuarios/:uuid" element={<PermissionGate permission="users.view"><UsuarioFormPage variante="backoffice" /></PermissionGate>} />

        {/* Cargos: o conjunto de áreas e permissões que o usuário herda. */}
        <Route path="/administrativo/cargos" element={<PermissionGate permission="users.view"><ResourceListPage config={cargosConfig} /></PermissionGate>} />
        <Route path={`${cargosConfig.basePath}/new`} element={<PermissionGate permission="users.view"><ResourceFormPage config={cargosConfig} /></PermissionGate>} />
        <Route path={`${cargosConfig.basePath}/:uuid`} element={<PermissionGate permission="users.view"><ResourceFormPage config={cargosConfig} /></PermissionGate>} />

        <Route path="/administrativo/auditoria" element={<PermissionGate permission="audit.view"><AuditoriaPage /></PermissionGate>} />
      </Route>
    </>
  )
}
